import MEmptyRitual from './MEmptyRitual.vue';

export { MEmptyRitual };
export default MEmptyRitual;
